module.exports = __webpack_public_path__ + "static/media/five.8c1c4635.svg";